import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(auth)/login/player/page.tsx");
